require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _DataTableCell = _interopRequireDefault(require("./DataTableCell"));

var _DataTableHeader2 = _interopRequireDefault(require("./DataTableHeader"));

var _DataTableTitle2 = _interopRequireDefault(require("./DataTableTitle"));

var _DataTablePagination2 = _interopRequireDefault(require("./DataTablePagination"));

var _DataTableRow2 = _interopRequireDefault(require("./DataTableRow"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/DataTable/DataTable.tsx";

var DataTable = function (_React$Component) {
  (0, _inherits2["default"])(DataTable, _React$Component);

  function DataTable() {
    (0, _classCallCheck2["default"])(this, DataTable);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DataTable).apply(this, arguments));
  }

  (0, _createClass2["default"])(DataTable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "style"]);
      return React.createElement(_reactNative.View, (0, _extends2["default"])({}, rest, {
        style: [styles.container, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 96
        }
      }), children);
    }
  }]);
  return DataTable;
}(React.Component);

(0, _defineProperty2["default"])(DataTable, "Header", _DataTableHeader2["default"]);
(0, _defineProperty2["default"])(DataTable, "Title", _DataTableTitle2["default"]);
(0, _defineProperty2["default"])(DataTable, "Row", _DataTableRow2["default"]);
(0, _defineProperty2["default"])(DataTable, "Cell", _DataTableCell["default"]);
(0, _defineProperty2["default"])(DataTable, "Pagination", _DataTablePagination2["default"]);

var styles = _reactNative.StyleSheet.create({
  container: {
    width: '100%'
  }
});

var _default = DataTable;
exports["default"] = _default;